import { SocketEvent } from '@/services/ws/core/event'
import { CASHBOX_EVENTS_WS } from '~/components/Cashbox/enum'

class UserModalBalanceEvent extends SocketEvent {
  async handle(data, { store }) {
    if (data.payload.type === CASHBOX_EVENTS_WS.MODAL_BALANCE_DEPOSIT)
      store.dispatch('user/act_modalBalance', data.payload)
  }
}

export const userModalBalanceEvent = new UserModalBalanceEvent()